export default "__VITE_ASSET__CHzwBzG___"